import { getProcessorJobsSchema, getProcessorJobSchema, getProcessorJobStagesSchema, getProcessorJobStageSchema, getProcessorJobStageTasksSchema, getProcessorJobStageTaskSchema, startPipelineResponseSchema, PipelineName, } from '@consigli/types';
import { createTransformer, createParams, mapToSnakeCase, } from './shared/base-api';
export const processorJobApiEndpoints = (builder, coreApiBaseUrl) => ({
    getProcessorJobs: builder.query({
        query: ({ projectId, packageId }) => `${coreApiBaseUrl}/projects/${projectId}/pipeline-jobs/${packageId != null ? `?package=${packageId}` : ''}`,
        providesTags: ['ProcessorJobs'],
        transformResponse: createTransformer(getProcessorJobsSchema, 'GetProcessorJobs'),
    }),
    getProcessorJob: builder.query({
        query: ({ projectId, jobId }) => `${coreApiBaseUrl}/projects/${projectId}/pipeline-jobs/${jobId}/`,
        providesTags: ['ProcessorJobs'],
        transformResponse: createTransformer(getProcessorJobSchema, 'GetProcessorJob'),
    }),
    getProcessorJobStages: builder.query({
        query: ({ projectId, jobId }) => `${coreApiBaseUrl}/projects/${projectId}/pipeline-jobs/${jobId}/stages/`,
        transformResponse: createTransformer(getProcessorJobStagesSchema, 'GetProcessorJobStages'),
    }),
    getProcessorJobStage: builder.query({
        query: ({ projectId, jobId, stageId }) => `${coreApiBaseUrl}/projects/${projectId}/pipeline-jobs/${jobId}/stages/${stageId}/`,
        transformResponse: createTransformer(getProcessorJobStageSchema, 'GetProcessorJobStage'),
    }),
    getProcessorJobStageTasks: builder.query({
        query: ({ projectId, jobId, stageId, page, pageSize, search, status }) => {
            const params = createParams({
                page,
                pageSize,
                search,
                status,
            });
            return {
                url: `${coreApiBaseUrl}/projects/${projectId}/pipeline-jobs/${jobId}/stages/${stageId}/tasks/`,
                method: 'GET',
                params: mapToSnakeCase(params),
            };
        },
        transformResponse: createTransformer(getProcessorJobStageTasksSchema, 'getProcessorJobStageTasks'),
    }),
    getProcessorJobStageTask: builder.query({
        query: ({ projectId, jobId, stageId, taskId }) => `${coreApiBaseUrl}/projects/${projectId}/pipeline-jobs/${jobId}/stages/${stageId}/tasks/${taskId}/`,
        transformResponse: createTransformer(getProcessorJobStageTaskSchema, 'getProcessorJobStageTask'),
    }),
    setProcessorJobCompletion: builder.mutation({
        query: ({ projectId, jobId, status }) => ({
            url: `${coreApiBaseUrl}/projects/${projectId}/pipeline-jobs/${jobId}/`,
            method: 'PATCH',
            body: {
                status,
            },
        }),
        invalidatesTags: ['ProcessorJobs'],
        transformResponse: createTransformer(getProcessorJobSchema, 'SetProcessorJobCompletion'),
    }),
    startPipeline: builder.mutation({
        query: ({ projectId, packageId, pipelineName = PipelineName.DEFAULT, secondaryPackageId, notify, jobType, metadata, }) => ({
            url: `${coreApiBaseUrl}/projects/${projectId}/pipeline-jobs/start/`,
            method: 'POST',
            body: mapToSnakeCase({
                projectId,
                packageId,
                pipelineName,
                secondaryPackageId,
                notify,
                jobType,
                metadata,
            }),
        }),
        transformResponse: createTransformer(startPipelineResponseSchema, 'startPipeline'),
        invalidatesTags: ['ProcessorJobs'],
    }),
});
